import "./hb-humanity.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

const avatar = new URL("../../../public/avatar.webp", import.meta.url).href;

export default (user) => html`
    <div
        id="hb-humanity"
        tabindex="-1"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        Proof of Humanity ℠
                    </h3>
                    <button
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-humanity">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="p-4 md:p-5">
                    <form class="space-y-4">
                        <!--<button
                            id="hb-humanity-avatar-upload"
                            class="${user?.photoURL
                            ? "hidden"
                            : ""} w-full mt-5">
                            <aside
                                class="relative mx-auto mb-[-20px] w-52 h-52 overflow-visible bg-violet-500 rounded-full">
                                <svg
                                    class="absolute w-48 h-48 text-gray-400 left-2 bottom-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <div
                                    class="absolute inline-flex items-center justify-center w-10 h-10 text-xs font-bold text-white bg-blue-500 border-2 border-white rounded-full top-2 end-2 dark:border-gray-500">
                                    <svg
                                        class="w-5 h-5"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512">
                                        <path
                                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                    </svg>
                                </div>
                            </aside>
                        </button>-->
                        <section class="relative mt-5 mb-10">
                            <aside
                                id="hb-humanity-avatar-photo"
                                class="w-52 h-52 mx-auto overflow-hidden bg-blue-400 rounded-full">
                                <img
                                    id="hb-humanity-avatar"
                                    class="h-full w-full rounded-full border-10 border-black dark:border-white"
                                    src="${user?.photoURL || avatar}"
                                    alt="Profile Picture" />
                            </aside>
                            <svg
                                id="hb-humanity-avatar-heart"
                                class="absolute top-1 end-11 w-15 h-15 animate-heartbeat"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="silver"
                                viewBox="0 0 24 24">
                                <path
                                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                    transform="rotate(45 12 12)" />
                            </svg>
                            <button
                                id="hb-humanity-avatar-remove"
                                class="${user?.photoURL
                                    ? ""
                                    : "hidden"} absolute bottom-3 right-3">
                                <svg
                                    class="w-5 h-5"
                                    fill="gray"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" />
                                </svg>
                            </button>
                            <button
                                id="hb-humanity-avatar-change"
                                class="absolute bottom-3 left-3">
                                <svg
                                    class="w-5 h-5"
                                    fill="gray"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512">
                                    <path
                                        d="M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0-10.4-31.2C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                                </svg>
                            </button>
                        </section>
                        <p
                            id="hb-humanity-message"
                            class="text-base font-medium mb-5 text-gray-500 dark:text-gray-300"></p>
                        <div
                            class="w-full inline-flex rounded-md shadow-xs"
                            role="group">
                            <button
                                id="hb-humanity-silver"
                                type="button"
                                class="w-full px-4 py-2 text-xs font-medium text-gray-900 bg-green-500 border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-green-500  dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Silver
                            </button>
                            <button
                                id="hb-humanity-mithril"
                                type="button"
                                class="w-full px-4 py-2 text-xs font-medium text-gray-900 bg-green-500 border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-green-500  dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Mithril
                            </button>
                            <button
                                id="hb-humanity-gold"
                                type="button"
                                class="w-full px-4 py-2 text-xs font-medium text-gray-900 bg-green-500 border-t border-b border-l border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-green-500  dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Gold
                            </button>
                            <button
                                id="hb-humanity-platinum"
                                type="button"
                                class="w-full px-4 py-2 text-xs font-medium text-gray-900 bg-green-500 border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-green-500  dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Platinum
                            </button>
                        </div>
                    </form>
                    <hb-account></hb-account>
                    <hb-mithril></hb-mithril>
                    <hb-gold></hb-gold>
                    <hb-platinum></hb-platinum>
                </div>
            </div>
        </div>
    </div>
`;
